import { ToastMessage } from '../types'

export const ACCOUNT_RETRIEVAL_FAILED =
  'There was an error retrieving the account. The request failed.'
export const ACCOUNT_OWNERS_RETRIEVAL_FAILED =
  'There was an error retrieving the account owners. The request failed.'
export const ASSET_RETRIEVAL_FAILED =
  'There was an error retrieving assets. The request failed.'
export const CASH_MARGIN_SHORT_CODE_PROPERTY_IDENTIFIER =
  'Cash Margin Short Code'
export const TRANSFER_RETRIEVAL_FAILED =
  'There was an error retrieving the transfers. The request failed.'
export const TEMPORARILY_UNAVAILABLE =
  'Sorry, this service is temporarily unavailable. Please check back later.'
export const MARGIN_RETRIEVAL_FAILED =
  'There was an error retrieving the margin details. The request failed.'
export const DOCUMENT_RETRIEVAL_FAILED =
  'There was an error retrieving the documents. The request failed.'
export const CASE_RETRIEVAL_FAILED =
  'There was an error retrieving the case. The request failed.'
export const AUDIT_TRAIL_RETRIEVAL_FAILED =
  'There was an error retrieving the audit trail. The request failed.'
export const CASE_ACCEPT_FAILED =
  'There was an error completing the case. The request failed.'
export const CASE_REJECT_FAILED =
  'There was an error declining the case. The request failed.'
export const CORRESPONDENT_RETRIEVAL_FAILED =
  'There was an error retrieving the correspondent. The request failed.'
export const TRANSFER_REQUEST_FAILED_MISCELLANEOUSLY =
  'There was an error submitting your transfer request. The request failed.'
export const getTransferRequestValidationFailed = (message: string) =>
  `There was an error submitting your transfer request. ${message} Please fix the error and try again.`
export const TRANSFER_SUCCESS: ToastMessage = {
  title: 'Transfer Request Confirmed',
  description: 'Your transfer request has been submitted for processing.',
}
